<template>
  <div class="mg-grid__item">
    <article
      class="mg-card md:max-w-sm overflow-hidden shadow-lg border-t-8 mg-border-accent-lighter p-8 pb-0 hentry bg-white rounded-lg"
    >
      <a v-if="post.mg_main_image" :href="post.mg_permalink">
        <img
          class="mb-4 block"
          :src="post.mg_main_image.sizes.large"
          :alt="
            post.mg_main_image.alt
              ? post.mg_main_image.alt
              : post.mg_main_image.title
          "
        />
      </a>
      <div class="mb-0">
        <h3
          class="text-lg tracking-medium leading-tight mb-6"
          :data-post-id="post.ID"
          :data-post-type="post.post_type"
        >
          <a :href="post.mg_permalink" class="plain-link">{{
            post.post_title
          }}</a>
        </h3>
        <div class="entry-meta">
          <ul class="list-reset flex mb-4 heading-font text-sm font-medium">
            <li>{{ display_date }}</li>
            <li
              v-if="post.mg_categories && post.mg_categories.length > 0"
              class="font-medium"
            >
              <span v-html="post.mg_categories"></span>
            </li>
          </ul>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
  import { format } from "date-fns";
  export default {
    props: ["post"],
    data() {
      return {
        summary: "",
        news_type: "",
        display_date: "",
      };
    },
    name: "card",
    methods: {
      setNewsType() {
        // Prioritize category name if available
        if (this.post.mg_category && this.post.mg_category.length > 0) {
          this.news_type = this.post.mg_category[0]["name"];
        } else if (this.post.post_type !== "post") {
          // Fall back to post type name if no category
          this.news_type = this.post.mg_type_name;
        }
      },
      makeSummary() {
        if (this.post.post_excerpt) {
          this.summary = this.post.post_excerpt;
        } else {
          const $htmlHolder = $("<div />");

          const contentPreview =
            this.post.post_content
              .split(" ")
              .splice(0, 24)
              .join(" ") + "...";

          $htmlHolder.html(contentPreview);

          this.summary = $htmlHolder.text();
        }
      },
      addDisplayDate() {
        this.display_date = format(this.post.post_date, "MMM D, YYYY");
      },
      updateMeta() {
        this.setNewsType();
        this.addDisplayDate();
        this.makeSummary();
      },
    },
    updated() {
      this.updateMeta();
    },
    created() {
      this.updateMeta();
    },
  };
</script>



// WEBPACK FOOTER //
// src/js/vue-components/card.vue